import { useContext } from 'react';
import ViewerIdentityContext from '../contexts/ViewerIdentityContext';

const FALLBACK_VALUE = {
  userId: null,
  user: null,
  sessionId: null,
  setUserId: () => {},
  setUser: () => {},
  signOut: () => {},
  refreshFromBackend: async () => {},
};

const useViewerIdentity = () => {
  const ctx = useContext(ViewerIdentityContext);
  return ctx ?? FALLBACK_VALUE;
};

export default useViewerIdentity;
